// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-select-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
}

.device-select-label {
  font-family: var(--mat-tab-header-label-text-font, Roboto, sans-serif);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.0892857em;
  text-transform: uppercase;
  color: var(--mat-tab-header-inactive-label-text-color);
}

.tab-panel {
  width: 100%;
  font-family: Roboto, sans-serif;
}
.tab-panel ::ng-deep .mat-mdc-tab-indicator .mat-mdc-tab-indicator-content {
  border-top-width: 3px;
}

.tab-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-right: 6px;
  vertical-align: middle;
}

.tab-content {
  padding: 24px 0 8px;
}

.system-sub-tabs {
  width: 100%;
}
.system-sub-tabs ::ng-deep .mat-mdc-tab-header {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
}
.system-sub-tabs ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  font-size: 13px;
}

.sub-tab-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  margin-right: 4px;
  vertical-align: middle;
}

.sub-tab-content {
  padding: 20px 0 8px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin: 0 0 12px;
}

.label-icon {
  font-size: 14px;
  height: 14px;
  width: 14px;
}
.label-icon--warn {
  color: hsl(41, 97%, 46%);
}
.label-icon--error {
  color: hsl(0, 88%, 55%);
}

.summary-grid {
  display: grid;
  gap: 12px;
  margin-bottom: 8px;
}
.summary-grid--3col {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.summary-grid--4col {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.summary-grid--5col {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.stat-card mat-card-content {
  padding: 16px !important;
}

.stat-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin: 0 0 4px;
}

.stat-value {
  font-size: 22px;
  font-weight: 500;
  margin: 0;
  color: hsl(234, 91%, 47%);
}
.stat-value--running {
  color: #2e7d32;
}
.stat-value--stopped {
  color: #c62828;
}
.stat-value--paused {
  color: hsl(240, 1%, 56%);
}
.stat-value--restarting {
  color: #1565c0;
}
.stat-value--warn {
  color: hsl(41, 97%, 46%);
}
.stat-value--error {
  color: hsl(0, 88%, 55%);
}

.info-card mat-card-content {
  padding: 0 !important;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.borderless-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.borderless-table th,
.borderless-table td {
  padding: 10px 16px;
  text-align: left;
  border: none;
}
.borderless-table th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.45);
}

.info-thead th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.45);
  padding: 10px 16px;
  text-align: left;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

.info-row-alt {
  background: rgba(0, 0, 0, 0.025);
}

.info-key {
  width: 40%;
  padding: 10px 16px;
  color: rgba(0, 0, 0, 0.55);
  font-weight: 500;
  border-right: 0.5px solid rgba(0, 0, 0, 0.08);
}

.info-val {
  padding: 10px 16px;
  color: rgba(0, 0, 0, 0.87);
  font-family: monospace;
  font-size: 12.5px;
}
.info-val--unit {
  color: rgba(0, 0, 0, 0.45);
  font-family: Roboto, sans-serif;
  font-size: 12px;
  width: 80px;
}

.state-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.state-dot.state-running {
  background: #2e7d32;
  box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.2);
}
.state-dot.state-stopped {
  background: #c62828;
}
.state-dot.state-paused {
  background: #e65100;
}
.state-dot.state-restarting {
  background: #1565c0;
}
.state-dot.state-active {
  background: #2e7d32;
  box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.2);
}
.state-dot.state-idle {
  background: #9e9e9e;
}
.state-dot.state-error {
  background: #c62828;
}

.mat-badge-warning ::ng-deep .mat-badge-content {
  background-color: hsl(41, 97%, 46%);
  color: hsl(234, 91%, 47%);
}

.mat-badge-error ::ng-deep .mat-badge-content {
  background-color: hsl(0, 88%, 55%);
  color: white;
}

.mat-badge-info ::ng-deep .mat-badge-content {
  background-color: hsl(234, 91%, 47%);
  color: white;
}

.state-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}
.state-badge.state-running {
  background: #e8f5e9;
  color: #2e7d32;
}
.state-badge.state-stopped {
  background: #fce4ec;
  color: #c62828;
}
.state-badge.state-paused {
  background: #fff3e0;
  color: #e65100;
}
.state-badge.state-restarting {
  background: #e3f2fd;
  color: #1565c0;
}

.container-accordion {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.container-panel ::ng-deep .mat-expansion-panel-header {
  padding: 0 16px;
  height: 52px;
}

.container-panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.container-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.container-id {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  background: rgba(0, 0, 0, 0.05);
  padding: 1px 6px;
  border-radius: 4px;
}

.container-panel-desc {
  display: flex;
  align-items: center;
  gap: 12px;
}

.container-image {
  font-size: 12px;
  font-family: monospace;
  color: rgba(0, 0, 0, 0.55);
}

.container-status-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.container-detail-grid {
  padding: 8px 0 12px;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dk {
  width: 120px;
  padding: 6px 16px 6px 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 500;
  vertical-align: top;
}

.dv {
  padding: 6px 0;
  color: rgba(0, 0, 0, 0.8);
  font-size: 12.5px;
}
.dv code {
  font-family: monospace;
  font-size: 12px;
}

.pill {
  display: inline-block;
  background: rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 10px;
  margin-right: 4px;
}

.pill-none {
  color: rgba(0, 0, 0, 0.3);
  font-size: 12px;
}

.mount-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.mount {
  display: block;
  font-size: 11px;
  font-family: monospace;
  color: rgba(0, 0, 0, 0.65);
  word-break: break-all;
}

.log-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.log-card {
  border-left: 3px solid transparent !important;
}
.log-card mat-card-content {
  padding: 12px 16px !important;
}
.log-card--warning {
  border-left-color: hsl(41, 97%, 46%) !important;
}
.log-card--error {
  border-left-color: hsl(0, 88%, 55%) !important;
}

.log-card-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.log-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}
.log-icon--warning {
  color: hsl(41, 97%, 46%);
}
.log-icon--error {
  color: #c62828;
}

.log-body {
  flex: 1;
  min-width: 0;
}

.log-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}

.log-source {
  font-size: 11px;
  font-family: monospace;
  color: rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.05);
  padding: 1px 6px;
  border-radius: 4px;
}

.log-ts {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  font-family: monospace;
}

.log-message {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.stream-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stream-card mat-card-content {
  padding: 12px 16px !important;
}

.stream-card-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stream-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stream-name {
  flex: 1;
  font-size: 12.5px;
  font-family: monospace;
  color: rgba(0, 0, 0, 0.8);
}

.stream-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 10px;
  text-transform: uppercase;
}
.stream-badge--active {
  background: #e8f5e9;
  color: #2e7d32;
}
.stream-badge--idle {
  background: #f5f5f5;
  color: #616161;
}
.stream-badge--error {
  background: #fce4ec;
  color: #c62828;
}

.stream-message {
  font-size: 12.5px;
  color: rgba(0, 0, 0, 0.55);
  margin: 0;
  padding-left: 16px;
  font-family: monospace;
}

.alert-summary-row {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.alert-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}
.alert-chip mat-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
}
.alert-chip--critical {
  background: #fee9e9;
  color: hsl(0, 88%, 55%);
}
.alert-chip--warning {
  background: #fff6e4;
  color: hsl(41, 97%, 46%);
}
.alert-chip--info {
  background: #e5e8fe;
  color: hsl(234, 91%, 47%);
}

.alert-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-card {
  border-left: 3px solid transparent !important;
}
.alert-card mat-card-content {
  padding: 14px 16px !important;
}
.alert-card--critical {
  border-left-color: hsl(0, 88%, 55%) !important;
}
.alert-card--warning {
  border-left-color: hsl(41, 97%, 46%) !important;
}
.alert-card--info {
  border-left-color: hsl(234, 91%, 47%) !important;
}

.alert-card-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.alert-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  margin-top: 1px;
}
.alert-icon--critical {
  color: hsl(0, 88%, 55%);
}
.alert-icon--warning {
  color: hsl(41, 97%, 46%);
}
.alert-icon--info {
  color: hsl(234, 91%, 47%);
}

.alert-body {
  flex: 1;
  min-width: 0;
}

.alert-message {
  font-size: 13.5px;
  color: rgba(0, 0, 0, 0.87);
  margin: 0 0 6px;
  line-height: 1.5;
}

.alert-device-id {
  cursor: pointer;
  text-decoration: underline;
}
.alert-device-id:hover {
  opacity: 0.7;
}

.alert-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-level-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 10px;
  letter-spacing: 0.05em;
}
.alert-level-badge--critical {
  background: #fee9e9;
  color: hsl(0, 88%, 55%);
}
.alert-level-badge--warning {
  background: #fff6e4;
  color: hsl(41, 97%, 46%);
}
.alert-level-badge--info {
  background: #e5e8fe;
  color: hsl(234, 91%, 47%);
}

.alert-ts {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  font-family: monospace;
}

@media (prefers-color-scheme: dark) {
  .section-label {
    color: rgba(255, 255, 255, 0.4);
  }
  .stat-label {
    color: rgba(255, 255, 255, 0.5);
  }
  .stat-value {
    color: rgba(255, 255, 255, 0.87);
  }
  .info-row-alt {
    background: rgba(255, 255, 255, 0.04);
  }
  .info-key {
    color: rgba(255, 255, 255, 0.45);
    border-right-color: rgba(255, 255, 255, 0.08);
  }
  .info-val {
    color: rgba(255, 255, 255, 0.87);
  }
  .info-thead th {
    color: rgba(255, 255, 255, 0.4);
    border-bottom-color: rgba(255, 255, 255, 0.1);
  }
  .container-name {
    color: rgba(255, 255, 255, 0.87);
  }
  .container-image {
    color: rgba(255, 255, 255, 0.5);
  }
  .container-status-text {
    color: rgba(255, 255, 255, 0.4);
  }
  .container-id {
    color: rgba(255, 255, 255, 0.35);
    background: rgba(255, 255, 255, 0.08);
  }
  .dk {
    color: rgba(255, 255, 255, 0.4);
  }
  .dv {
    color: rgba(255, 255, 255, 0.8);
  }
  .pill {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.65);
  }
  .mount {
    color: rgba(255, 255, 255, 0.55);
  }
  .log-source {
    color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.07);
  }
  .log-ts {
    color: rgba(255, 255, 255, 0.35);
  }
  .log-message {
    color: rgba(255, 255, 255, 0.8);
  }
  .stream-name {
    color: rgba(255, 255, 255, 0.8);
  }
  .stream-message {
    color: rgba(255, 255, 255, 0.45);
  }
  .alert-message {
    color: rgba(255, 255, 255, 0.87);
  }
  .alert-ts {
    color: rgba(255, 255, 255, 0.35);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/edge-device-dashboard/edge-device-dashboard.component.scss"],"names":[],"mappings":"AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AATF;;AAYA;EACE,sEAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sDAAA;AATF;;AAaA;EACE,WAAA;EACA,+BAAA;AAVF;AAYE;EACE,qBAAA;AAVJ;;AAcA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAeA;EACE,WAAA;AAZF;AAcE;EACE,8CAAA;AAZJ;AAeE;EACE,eAAA;AAbJ;;AAiBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAfF;AAiBE;EACE,wBA5FY;AA6EhB;AAkBE;EACE,uBA/FU;AA+Ed;;AAqBA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,gDAAA;AAlBJ;AAqBE;EACE,gDAAA;AAnBJ;AAsBE;EACE,gDAAA;AApBJ;;AA0BE;EACE,wBAAA;AAvBJ;;AA2BA;EACE,eAAA;EACA,0BAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAtIW;AA8Gb;AA0BE;EACE,cAAA;AAxBJ;AA2BE;EACE,cAAA;AAzBJ;AA4BE;EACE,wBAhJa;AAsHjB;AA6BE;EACE,cAAA;AA3BJ;AA8BE;EACE,wBA3JY;AA+HhB;AA+BE;EACE,uBA9JU;AAiId;;AAmCE;EACE,qBAAA;AAhCJ;;AAoCA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAjCF;AAmCE;;EAEE,kBAAA;EACA,gBAAA;EACA,YAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;AAlCJ;;AAsCA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AAnCF;;AAsCA;EACE,gCAAA;AAnCF;;AAsCA;EACE,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,6CAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;EACA,iBAAA;AAnCF;AAqCE;EACE,0BAAA;EACA,+BAAA;EACA,eAAA;EACA,WAAA;AAnCJ;;AAwCA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AArCF;AAuCE;EACE,mBAAA;EACA,4CAAA;AArCJ;AAwCE;EACE,mBAAA;AAtCJ;AAyCE;EACE,mBAAA;AAvCJ;AA0CE;EACE,mBAAA;AAxCJ;AA2CE;EACE,mBAAA;EACA,4CAAA;AAzCJ;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,mBAAA;AA3CJ;;AAgDE;EACE,mCAnRY;EAoRZ,yBAlRS;AAqOb;;AAmDE;EACE,kCA1RU;EA2RV,YAAA;AAhDJ;;AAqDE;EACE,oCAhSS;EAiST,YAAA;AAlDJ;;AAsDA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAnDF;AAqDE;EACE,mBAAA;EACA,cAAA;AAnDJ;AAsDE;EACE,mBAAA;EACA,cAAA;AApDJ;AAuDE;EACE,mBAAA;EACA,cAAA;AArDJ;AAwDE;EACE,mBAAA;EACA,cAAA;AAtDJ;;AA2DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxDF;;AA4DE;EACE,eAAA;EACA,YAAA;AAzDJ;;AA6DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,sBAAA;EACA,0BAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,0BAAA;AA1DF;;AA6DA;EACE,mBAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;AA1DF;AA4DE;EACE,sBAAA;EACA,eAAA;AA1DJ;;AA8DA;EACE,qBAAA;EACA,+BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3DF;;AA8DA;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,qBAAA;AA3DF;;AA+DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5DF;;AA+DA;EACE,6CAAA;AA5DF;AA8DE;EACE,6BAAA;AA5DJ;AA+DE;EACE,+CAAA;AA7DJ;AAgEE;EACE,8CAAA;AA9DJ;;AAkEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AA/DF;AAiEE;EACE,wBAtdY;AAuZhB;AAmEE;EACE,cAAA;AAjEJ;;AAqEA;EACE,OAAA;EACA,YAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,yBAAA;EACA,SAAA;EACA,qBAAA;EACA,sBAAA;AAlEF;;AAsEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnEF;;AAuEE;EACE,6BAAA;AApEJ;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArEF;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArEF;;AAwEA;EACE,OAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AArEF;AAuEE;EACE,mBAAA;EACA,cAAA;AArEJ;AAwEE;EACE,mBAAA;EACA,cAAA;AAtEJ;AAyEE;EACE,mBAAA;EACA,cAAA;AAvEJ;;AA2EA;EACE,iBAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AAxEF;;AA4EA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAzEJ;AA4EE;EACE,mBAAA;EACA,uBAzlBU;AA+gBd;AA6EE;EACE,mBAAA;EACA,wBA/lBY;AAohBhB;AA8EE;EACE,mBAAA;EACA,yBAlmBS;AAshBb;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7EF;;AAgFA;EACE,6CAAA;AA7EF;AA+EE;EACE,6BAAA;AA7EJ;AAgFE;EACE,8CAAA;AA9EJ;AAiFE;EACE,+CAAA;AA/EJ;AAkFE;EACE,gDAAA;AAhFJ;;AAoFA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAjFF;AAmFE;EACE,uBA/oBU;AA8jBd;AAoFE;EACE,wBAppBY;AAkkBhB;AAqFE;EACE,yBAtpBS;AAmkBb;;AAuFA;EACE,OAAA;EACA,YAAA;AApFF;;AAuFA;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AApFF;;AAuFA;EACE,eAAA;EACA,0BAAA;AApFF;AAsFE;EACE,YAAA;AApFJ;;AAwFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AArFF;;AAwFA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AArFF;AAuFE;EACE,mBAAA;EACA,uBA/rBU;AA0mBd;AAwFE;EACE,mBAAA;EACA,wBArsBY;AA+mBhB;AAyFE;EACE,mBAAA;EACA,yBAxsBS;AAinBb;;AA2FA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;AAxFF;;AA4FA;EACE;IACE,+BAAA;EAzFF;EA4FA;IACE,+BAAA;EA1FF;EA6FA;IACE,gCAAA;EA3FF;EA8FA;IACE,qCAAA;EA5FF;EA+FA;IACE,gCAAA;IACA,6CAAA;EA7FF;EAgGA;IACE,gCAAA;EA9FF;EAiGA;IACE,+BAAA;IACA,6CAAA;EA/FF;EAkGA;IACE,gCAAA;EAhGF;EAmGA;IACE,+BAAA;EAjGF;EAoGA;IACE,+BAAA;EAlGF;EAqGA;IACE,gCAAA;IACA,qCAAA;EAnGF;EAsGA;IACE,+BAAA;EApGF;EAuGA;IACE,+BAAA;EArGF;EAwGA;IACE,oCAAA;IACA,gCAAA;EAtGF;EAyGA;IACE,gCAAA;EAvGF;EA0GA;IACE,+BAAA;IACA,qCAAA;EAxGF;EA2GA;IACE,gCAAA;EAzGF;EA4GA;IACE,+BAAA;EA1GF;EA6GA;IACE,+BAAA;EA3GF;EA8GA;IACE,gCAAA;EA5GF;EA+GA;IACE,gCAAA;EA7GF;EAgHA;IACE,gCAAA;EA9GF;AACF","sourcesContent":["@use 'sass:color';\n\n$color-warning: hsl(41, 97%, 46%);\n$color-error: hsl(0, 88%, 55%);\n$color-info: hsl(234, 91%, 47%);\n$color-disabled: hsl(240, 1%, 56%);\n$alert-chip-backlight: 90%;\n\n\n// ─── Device selector ─────────────────────────────────────────────────────────\n.device-select-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-left: 16px;\n}\n\n.device-select-label {\n  font-family: var(--mat-tab-header-label-text-font, Roboto, sans-serif);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.0892857em;\n  text-transform: uppercase;\n  color: var(--mat-tab-header-inactive-label-text-color);\n}\n\n// ─── Tab group host ──────────────────────────────────────────────────────────\n.tab-panel {\n  width: 100%;\n  font-family: Roboto, sans-serif;\n\n  ::ng-deep .mat-mdc-tab-indicator .mat-mdc-tab-indicator-content {\n    border-top-width: 3px;\n  }\n}\n\n.tab-icon {\n  font-size: 18px;\n  height: 18px;\n  width: 18px;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n.tab-content {\n  padding: 24px 0 8px;\n}\n\n// ─── Nested sub-tabs ─────────────────────────────────────────────────────────\n.system-sub-tabs {\n  width: 100%;\n\n  ::ng-deep .mat-mdc-tab-header {\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);\n  }\n\n  ::ng-deep .mat-mdc-tab .mdc-tab__text-label {\n    font-size: 13px;\n  }\n}\n\n.sub-tab-icon {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n  margin-right: 4px;\n  vertical-align: middle;\n}\n\n.sub-tab-content {\n  padding: 20px 0 8px;\n}\n\n// ─── Section label ───────────────────────────────────────────────────────────\n.section-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.45);\n  margin: 0 0 12px;\n}\n\n.label-icon {\n  font-size: 14px;\n  height: 14px;\n  width: 14px;\n\n  &--warn {\n    color: $color-warning;\n  }\n\n  &--error {\n    color: $color-error;\n  }\n}\n\n// ─── Summary grids ───────────────────────────────────────────────────────────\n.summary-grid {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 8px;\n\n  &--3col {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  &--4col {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  &--5col {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n// ─── Stat cards ──────────────────────────────────────────────────────────────\n.stat-card {\n  mat-card-content {\n    padding: 16px !important;\n  }\n}\n\n.stat-label {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.55);\n  margin: 0 0 4px;\n}\n\n.stat-value {\n  font-size: 22px;\n  font-weight: 500;\n  margin: 0;\n  color: $color-info;\n\n  &--running {\n    color: #2e7d32;\n  }\n\n  &--stopped {\n    color: #c62828;\n  }\n\n  &--paused {\n    color: $color-disabled;\n  }\n\n  &--restarting {\n    color: #1565c0;\n  }\n\n  &--warn {\n    color: $color-warning;\n  }\n\n  &--error {\n    color: $color-error;\n  }\n}\n\n// ─── Info / key-value table ───────────────────────────────────────────────────\n.info-card {\n  mat-card-content {\n    padding: 0 !important;\n  }\n}\n\n.info-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.borderless-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n\n  th,\n  td {\n    padding: 10px 16px;\n    text-align: left;\n    border: none;\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(0, 0, 0, 0.45);\n  }\n}\n\n.info-thead th {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(0, 0, 0, 0.45);\n  padding: 10px 16px;\n  text-align: left;\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n\n.info-row-alt {\n  background: rgba(0, 0, 0, 0.025);\n}\n\n.info-key {\n  width: 40%;\n  padding: 10px 16px;\n  color: rgba(0, 0, 0, 0.55);\n  font-weight: 500;\n  border-right: 0.5px solid rgba(0, 0, 0, 0.08);\n}\n\n.info-val {\n  padding: 10px 16px;\n  color: rgba(0, 0, 0, 0.87);\n  font-family: monospace;\n  font-size: 12.5px;\n\n  &--unit {\n    color: rgba(0, 0, 0, 0.45);\n    font-family: Roboto, sans-serif;\n    font-size: 12px;\n    width: 80px;\n  }\n}\n\n// ─── State indicators ─────────────────────────────────────────────────────────\n.state-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n\n  &.state-running {\n    background: #2e7d32;\n    box-shadow: 0 0 0 2px rgba(46, 125, 50, .2);\n  }\n\n  &.state-stopped {\n    background: #c62828;\n  }\n\n  &.state-paused {\n    background: #e65100;\n  }\n\n  &.state-restarting {\n    background: #1565c0;\n  }\n\n  &.state-active {\n    background: #2e7d32;\n    box-shadow: 0 0 0 2px rgba(46, 125, 50, .2);\n  }\n\n  &.state-idle {\n    background: #9e9e9e;\n  }\n\n  &.state-error {\n    background: #c62828;\n  }\n}\n\n.mat-badge-warning {\n  ::ng-deep .mat-badge-content {\n    background-color: $color-warning;\n    color: $color-info\n\n  }\n}\n\n.mat-badge-error {\n  ::ng-deep .mat-badge-content {\n    background-color: $color-error;\n    color: white;\n  }\n}\n\n.mat-badge-info {\n  ::ng-deep .mat-badge-content {\n    background-color: $color-info;\n    color: white;\n  }\n}\n\n.state-badge {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 500;\n\n  &.state-running {\n    background: #e8f5e9;\n    color: #2e7d32;\n  }\n\n  &.state-stopped {\n    background: #fce4ec;\n    color: #c62828;\n  }\n\n  &.state-paused {\n    background: #fff3e0;\n    color: #e65100;\n  }\n\n  &.state-restarting {\n    background: #e3f2fd;\n    color: #1565c0;\n  }\n}\n\n// ─── Containers ──────────────────────────────────────────────────────────────\n.container-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.container-panel {\n  ::ng-deep .mat-expansion-panel-header {\n    padding: 0 16px;\n    height: 52px;\n  }\n}\n\n.container-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.container-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.container-id {\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.4);\n  background: rgba(0, 0, 0, 0.05);\n  padding: 1px 6px;\n  border-radius: 4px;\n}\n\n.container-panel-desc {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.container-image {\n  font-size: 12px;\n  font-family: monospace;\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.container-status-text {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.container-detail-grid {\n  padding: 8px 0 12px;\n}\n\n.detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.dk {\n  width: 120px;\n  padding: 6px 16px 6px 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 500;\n  vertical-align: top;\n}\n\n.dv {\n  padding: 6px 0;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 12.5px;\n\n  code {\n    font-family: monospace;\n    font-size: 12px;\n  }\n}\n\n.pill {\n  display: inline-block;\n  background: rgba(0, 0, 0, 0.06);\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 11px;\n  padding: 1px 8px;\n  border-radius: 10px;\n  margin-right: 4px;\n}\n\n.pill-none {\n  color: rgba(0, 0, 0, 0.3);\n  font-size: 12px;\n}\n\n.mount-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.mount {\n  display: block;\n  font-size: 11px;\n  font-family: monospace;\n  color: rgba(0, 0, 0, 0.65);\n  word-break: break-all;\n}\n\n// ─── Logs ────────────────────────────────────────────────────────────────────\n.log-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.log-card {\n  border-left: 3px solid transparent !important;\n\n  mat-card-content {\n    padding: 12px 16px !important;\n  }\n\n  &--warning {\n    border-left-color: $color-warning !important;\n  }\n\n  &--error {\n    border-left-color: $color-error !important;\n  }\n}\n\n.log-card-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.log-icon {\n  font-size: 18px;\n  height: 18px;\n  width: 18px;\n  flex-shrink: 0;\n  margin-top: 1px;\n\n  &--warning {\n    color: $color-warning;\n    // background-color: $color-warning;\n  }\n\n  &--error {\n    color: #c62828;\n  }\n}\n\n.log-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.log-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n\n.log-source {\n  font-size: 11px;\n  font-family: monospace;\n  color: rgba(0, 0, 0, 0.5);\n  background: rgba(0, 0, 0, 0.05);\n  padding: 1px 6px;\n  border-radius: 4px;\n}\n\n.log-ts {\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.4);\n  font-family: monospace;\n}\n\n.log-message {\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.8);\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n// ─── Streams ─────────────────────────────────────────────────────────────────\n.stream-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stream-card {\n  mat-card-content {\n    padding: 12px 16px !important;\n  }\n}\n\n.stream-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stream-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stream-name {\n  flex: 1;\n  font-size: 12.5px;\n  font-family: monospace;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.stream-badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n\n  &--active {\n    background: #e8f5e9;\n    color: #2e7d32;\n  }\n\n  &--idle {\n    background: #f5f5f5;\n    color: #616161;\n  }\n\n  &--error {\n    background: #fce4ec;\n    color: #c62828;\n  }\n}\n\n.stream-message {\n  font-size: 12.5px;\n  color: rgba(0, 0, 0, 0.55);\n  margin: 0;\n  padding-left: 16px;\n  font-family: monospace;\n}\n\n// ─── Alerts ──────────────────────────────────────────────────────────────────\n.alert-summary-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.alert-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n\n  mat-icon {\n    font-size: 16px;\n    height: 16px;\n    width: 16px;\n  }\n\n  &--critical {\n    background: color.scale($color-error, $lightness: $alert-chip-backlight);\n    color: $color-error;\n  }\n\n  &--warning {\n    background: color.scale($color-warning, $lightness: $alert-chip-backlight);\n    color: $color-warning\n  }\n\n  &--info {\n    background: color.scale($color-info, $lightness: $alert-chip-backlight);\n    color: $color-info;\n  }\n}\n\n.alert-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.alert-card {\n  border-left: 3px solid transparent !important;\n\n  mat-card-content {\n    padding: 14px 16px !important;\n  }\n\n  &--critical {\n    border-left-color: $color-error !important;\n  }\n\n  &--warning {\n    border-left-color: $color-warning !important;\n  }\n\n  &--info {\n    border-left-color: $color-info !important;\n  }\n}\n\n.alert-card-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.alert-icon {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n  flex-shrink: 0;\n  margin-top: 1px;\n\n  &--critical {\n    color: $color-error\n  }\n\n  &--warning {\n    color: $color-warning\n  }\n\n  &--info {\n    color: $color-info\n  }\n}\n\n.alert-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.alert-message {\n  font-size: 13.5px;\n  color: rgba(0, 0, 0, 0.87);\n  margin: 0 0 6px;\n  line-height: 1.5;\n}\n\n.alert-device-id {\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.alert-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.alert-level-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 1px 8px;\n  border-radius: 10px;\n  letter-spacing: 0.05em;\n\n  &--critical {\n    background: color.scale($color-error, $lightness: $alert-chip-backlight);\n    color: $color-error;\n  }\n\n  &--warning {\n    background: color.scale($color-warning, $lightness: $alert-chip-backlight);\n    color: $color-warning;\n  }\n\n  &--info {\n    background: color.scale($color-info, $lightness: $alert-chip-backlight);\n    color: $color-info\n  }\n}\n\n.alert-ts {\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.4);\n  font-family: monospace;\n}\n\n// ─── Dark mode ───────────────────────────────────────────────────────────────\n@media (prefers-color-scheme: dark) {\n  .section-label {\n    color: rgba(255, 255, 255, 0.4);\n  }\n\n  .stat-label {\n    color: rgba(255, 255, 255, 0.5);\n  }\n\n  .stat-value {\n    color: rgba(255, 255, 255, 0.87);\n  }\n\n  .info-row-alt {\n    background: rgba(255, 255, 255, 0.04);\n  }\n\n  .info-key {\n    color: rgba(255, 255, 255, 0.45);\n    border-right-color: rgba(255, 255, 255, 0.08);\n  }\n\n  .info-val {\n    color: rgba(255, 255, 255, 0.87);\n  }\n\n  .info-thead th {\n    color: rgba(255, 255, 255, 0.4);\n    border-bottom-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .container-name {\n    color: rgba(255, 255, 255, 0.87);\n  }\n\n  .container-image {\n    color: rgba(255, 255, 255, 0.5);\n  }\n\n  .container-status-text {\n    color: rgba(255, 255, 255, 0.4);\n  }\n\n  .container-id {\n    color: rgba(255, 255, 255, 0.35);\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  .dk {\n    color: rgba(255, 255, 255, 0.4);\n  }\n\n  .dv {\n    color: rgba(255, 255, 255, 0.8);\n  }\n\n  .pill {\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.65);\n  }\n\n  .mount {\n    color: rgba(255, 255, 255, 0.55);\n  }\n\n  .log-source {\n    color: rgba(255, 255, 255, 0.4);\n    background: rgba(255, 255, 255, 0.07);\n  }\n\n  .log-ts {\n    color: rgba(255, 255, 255, 0.35);\n  }\n\n  .log-message {\n    color: rgba(255, 255, 255, 0.8);\n  }\n\n  .stream-name {\n    color: rgba(255, 255, 255, 0.8);\n  }\n\n  .stream-message {\n    color: rgba(255, 255, 255, 0.45);\n  }\n\n  .alert-message {\n    color: rgba(255, 255, 255, 0.87);\n  }\n\n  .alert-ts {\n    color: rgba(255, 255, 255, 0.35);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
